exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-modules-layout-components-MainPanel-___styles__panel___32j-z {\n  padding: 1em; }\n", ""]);

// Exports
exports.locals = {
	"panel": "src-modules-layout-components-MainPanel-___styles__panel___32j-z"
};